// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__3v0gq"};